<template>
    <div class="base-select"
         @mouseleave="hover = false"
         @mouseover="hover = true"
         :title="getTooltip">
        <div @click="toggleList()" class="select align-center justify-between">
            <span class="ellipsis">{{label}}</span>

            <div class="align-center">
<!--                <span class="blue-text">{{costChanged}}</span>-->
                <svg width="10px" height="5px" :class="['drop-icon', {'rotate': showList}]" fill="var(--lighten-5-color)">
                    <use xlink:href="../../assets/images/sprite.svg#drop-angle"></use>
                </svg>
            </div>
        </div>
        <div ref="dropDownList" 
             v-show="showList"
             :style="{maxHeight: maxHeight + 'px'}"
             :class="['drop-down-list', {'position-left': !positionRight}, {'position-right': positionRight}]" >
            <div v-for="(item, key) in list"
                 :key="key"
                 :class="['drop-down-item align-center justify-between', {'active': item.label+''+item.value === label+''+select}, {'focus': keyMove.position === key}, {'drop-down-item-duration': isDuration}]"
                 ref="dropDownItem"
                 @click="changeItem(item)">
                <span class="nowrap ellipsis drop-down-item-label">{{item.label}}</span>
                <span v-if="item.label+''+item.value !== label+''+select" class="second-label nowrap">{{item.secondLabel}}</span>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "base-select",
        data() {
            return {
                showList: false,
                label: "",
                // secondLabel: "",
                hover: false,
                select: null,
                list: [],
                keyMove: {
                    position: 0,
                    move: false
                }
            }
        },
        props: {
            items: {
                type: Array,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            },
            value: {
                type: [String, Number],
            },
            costChanged: {
                type: String,
                default: ''
            },
            isDuration: {
                type: Boolean,
                default: false
            },
            stateTransferCheckbox: {
                type: Boolean,
                default: false
            },
            tooltip: {
                type: Boolean,
                default: false
            },
            maxHeight: {
                type: Number,
                default: 136
            },
            positionRight: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            this.list = [];
            this.items.forEach(x => {
                this.list.push(Object.assign({}, x))
            })
            this.label = this.list.legth && this.list[0].value === this.value ? this.list[0].label : "";
            // this.secondLabel = this.list.legth && this.list[0].value === this.value ? this.list[0].secondLabel : "";
            this.select = this.value;
        },
        computed: {
            getTooltip() {
                if (this.tooltip && !this.showList) {
                    return this.label
                } else {
                    return ''
                }
            }
        },
        methods: {
            keyUp(e) {
                // if (!this.showList) {
                //     return
                // }
                this.keyMove.move = true
                if (e.keyCode === 40) {
                    e.preventDefault();
                    if (this.keyMove.position + 1 < this.list.length) {
                        this.keyMove.position++;
                        this.list.forEach((x, i) => {
                            if (i === this.keyMove.position) {
                                this.$refs.dropDownList.scrollTo(0, i * this.$refs.dropDownItem[0].offsetHeight);
                            }
                        })
                    }
                }
                if (e.keyCode === 38) {
                    e.preventDefault()
                    if (this.keyMove.position > 0) {
                        this.keyMove.position--;
                        this.list.forEach((x, i) => {
                            if (i === this.keyMove.position) {
                                this.$refs.dropDownList.scrollTo(0, i * this.$refs.dropDownItem[0].offsetHeight);
                            }
                        })
                    }
                }
                if (e.keyCode === 13) {
                    let item = this.list.find((x, i) => i === this.keyMove.position);
                    this.changeItem(item)
                }
            },
            outside() {
                if (!this.hover) {
                    this.hideList();
                }
            },
            toggleList() {
                if (!this.disabled) {
                    this.showList = !this.showList;

                    if(!this.showList) {
                      this.$emit('dropdown-close')
                    }
                }
            },
            changeItem(item) {
                this.label = item.label;

                // const defaultCost = this.items[0].allData.Details[0].Cost;
                // const rate = item.secondLabel.split(' ').reverse()[0];
                // const costChanged = item.allData.Details[0].Cost - defaultCost;
                // this.secondLabel = (costChanged > 0 ? '+' : '') +this.correctPrice(costChanged, true) + " " + rate;
                // if (costChanged === 0) this.secondLabel = '';

                this.select = item.value;
                this.hideList();

                this.$emit("change", item)
            },
            // correctPrice(val, round = false) {
            //     if (round) {
            //         val = Math.round(val);
            //     }
            //     const isFloat = val % 1 !== 0;
            //     let res = new Intl.NumberFormat().format(val);
            //
            //     if (res.includes(".") || !isFloat) {
            //         res = res.replace(/,/g, " ");
            //     } else {
            //         res = res.replace(/,/g, ".");
            //     }
            //     res = (res.includes("NaN") || isNaN(parseInt(res))) ? "" : res;
            //     return res
            // },
            hideList() {
                this.showList = false;
            }
        },
        watch: {
            stateTransferCheckbox(val) {
              if (val) {
                this.changeItem(this.list[0])
              }
            },
            items: {
                deep: true,
                handler(val) {
                    if (!val) return;

                    this.list = [];
                    this.items.forEach(x => {
                        this.list.push(Object.assign({}, x))
                    })
                    if (!val.length) {
                        this.label = ""
                    } else {
                        this.list.forEach(x => {
                            if (x.value === this.value) {
                                this.label = x.label;
                                // this.secondLabel = x.secondLabel;
                            }
                        })
                    }
                }
            },
            value(val) {
                this.select = val;
            },
            select(val) {
                let index = this.list.map(x => x.value).indexOf(val)
                if (index !== -1) {
                    this.label = this.list[index].label
                    // this.secondLabel = this.list[index].secondLabel
                }
                this.$emit("input", val)
            },
            showList(val) {
                if (val) {
                    this.$emit("toggle", true);
                    setTimeout(() => this.$emit("toggle", true), 0)
                    window.addEventListener("click", this.outside);
                    window.addEventListener('keyup', this.keyUp);
                } else {
                    this.$emit("toggle", false);
                    window.removeEventListener("click", this.outside);
                    window.removeEventListener('keyup', this.keyUp);
                }
            }
        },
        updated() {
            if (this.showList && !this.keyMove.move) {
                this.list.forEach((x, i) => {
                    if (x.label === this.label) {
                        this.$refs.dropDownList.scrollTo(0, i * this.$refs.dropDownItem[0].offsetHeight)
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .base-select {
        position: relative;
        width: 100%;
    }
    .base-select .second-label {
        color: var(--primary-color);
    }

    .base-select .select {
        position: relative;
        width: 100%;
        border: none;
        outline: none;
        padding: 12px 40px 12px 12px;
        background-color: var(--lighten-6-color);
        border-radius: 3px;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #333;
        cursor: pointer;
    }

    .base-select .select .drop-icon{
        position: absolute;
        top: calc(50% - 2px);
        right: 11px;
        transition: all .2s;
    }

    .base-select .select .drop-icon.rotate{
        transform: rotate(180deg)
    }

    .base-select .drop-down-list {
        min-width: 100%;
        max-height: 136px;
        overflow-y: auto;
        overflow-x: hidden;
        position: absolute;
        top: 100%;
        border-radius: 4px;
        box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
        padding: 4px 0;
        background-color: var(--white-color);
        z-index: 10;
    }
 
    .base-select .drop-down-list.position-left {
        left: 0;
    }

    .base-select .drop-down-list.position-right {
        right: 0;
    }

    .base-select .drop-down-list .drop-down-item {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: var(--dark-1-color);
        padding: 4px 12px;
        transition: all .2s;
        cursor: pointer;
    }
    
    .base-select .drop-down-list .drop-down-item-duration {
        font-size: 15px;
        line-height: 17px;
    }

    .base-select .drop-down-list .drop-down-item:hover,
    .base-select .drop-down-list .drop-down-item.focus {
        background-color: rgba(229, 243, 253, .5);
    }
    .base-select .drop-down-list .drop-down-item.active {
        background-color: var(--primary-2-color);
    }
    .base-select .drop-down-list .drop-down-item .drop-down-item-label {
        max-width: 450px;
    }
</style>
